/**
 * Puits à or (gold well) — sink idle infini : injecter de l'or → +DPS permanent.
 *
 * Coût exponentiel brutal, bonus DPS additif (rendement réel décroissant). Permanent
 * (survit à l'ascension). Derrière le flag serveur `goldWellEnabled`. Courbe paramétrée sur
 * l'économie réelle (or/h ≈ dizaines de K early → ≈ centaines de M endgame sanctuaire) — tunable.
 */
import { goldWellCostFactor } from "./economy_modifiers.mjs";

export const GOLD_WELL_BASE_COST = 10_000;
/** Croissance adoucie (2.0) pour coller à l’économie or ÷5 — T20+ redevient atteignable. */
export const GOLD_WELL_COST_GROWTH = 2.0;
/** +3 % DPS par palier (additif). */
export const GOLD_WELL_DPS_STEP = 0.03;
/** Plafond de sécurité (effectivement infini : le coût rend les hauts paliers inatteignables). */
export const GOLD_WELL_MAX_LEVEL = 100;

/**
 * Tier 3 (synergie) : chaque génération Pokédex complétée amplifie le *bonus* DPS du Puits
 * de +3 % (multiplicatif sur la part au-dessus de 1). À 9 gens : bonus Puits ×1,27.
 * Appliqué seulement quand le flag `ascension_synergy_enabled` est actif (sinon `genCount`=0).
 */
export const GOLD_WELL_POKEDEX_AMP_PER_GEN = 0.03;

/**
 * Coût (or) pour acheter le palier `nextLevel` (1 = tout premier palier).
 * `goldWellCostFactor()` = modificateur admin live (neutre par défaut).
 */
export function getGoldWellTierCost(nextLevel: number): number {
  const n = Math.max(1, Math.floor(Number(nextLevel) || 1));
  return Math.max(
    1,
    Math.ceil(
      GOLD_WELL_BASE_COST *
        Math.pow(GOLD_WELL_COST_GROWTH, n - 1) *
        goldWellCostFactor(),
    ),
  );
}

/**
 * Multiplicateur DPS au niveau de Puits donné. >= 1.
 * `completedGenCount` (Tier 3) amplifie le bonus ; 0 = comportement historique.
 */
export function getGoldWellDpsMult(
  level: number,
  completedGenCount = 0,
): number {
  const n = Math.max(
    0,
    Math.min(GOLD_WELL_MAX_LEVEL, Math.floor(Number(level) || 0)),
  );
  const gens = Math.max(0, Math.floor(Number(completedGenCount) || 0));
  const amp = 1 + gens * GOLD_WELL_POKEDEX_AMP_PER_GEN;
  return 1 + n * GOLD_WELL_DPS_STEP * amp;
}
